import { Link } from 'react-router-dom';

import {
    H1,
    ButtonVariant,
    PublicLayout,
    CardContainer,
    Button,
    theme,
} from '@catalyze/ui';
import { Routes } from 'constants/routes';
import { SignInForm } from 'features/SignIn/components/SignInForm';

import {
    StyledText,
    ResetContainer,
    StyledLabelText,
    StyledLinkText,
} from './styled';

const Navigation = (
    <Button
        as="a"
        className="showMobile"
        href={Routes.MAIN_SITE_SIGN_UP}
        variant={ButtonVariant.SECONDARY}
    >
        Sign up
    </Button>
);

export const SignIn = () => (
    <PublicLayout navigation={Navigation}>
        <CardContainer>
            <H1>Welcome back</H1>
            <StyledText>
                Enter your credentials to sign in to Catalyze AI.
            </StyledText>
            <SignInForm />
        </CardContainer>
        <ResetContainer>
            <StyledLabelText color={theme.colors.fontSearch}>
                Forgot password?
            </StyledLabelText>
            <Link to={Routes.RESET_PASSWORD}>
                <StyledLinkText bold> Reset Password</StyledLinkText>
            </Link>
        </ResetContainer>
    </PublicLayout>
);
